import React from 'react';
import Hero from '../elements/Hero.js';
import AboutBanner from '../img/about_banner.png';
import Title from '../elements/Title.js';
import Footer from '../elements/Footer.js';
import Newsletter from '../elements/Newsletter.js';
import packvideo from '../img/packvideo.png';
import movie from '../video/movie.mp4';
import Checklist from '../elements/Checklist.js';
import Btn from '../elements/Btn.js';
import s4 from '../img/locate_worldwide.png';
import Counter from '../elements/Counter.js';
import BookingImage from "../img/booking.png";
import BookingImage1 from "../img/booking1.png";
import BookingImage3 from "../img/booking3.png";
import CustomerCare1 from "../img/customer_care.png";
import CustomerCare2 from "../img/customer_care2.png";
import TriImage from '../elements/TriImage';
import AboutExquisiteRight from '../img/about_exquisite_right.png';
import AboutExquisiteleft1 from '../img/about_exquisite_left1.png';
import AboutExquisiteleft2 from '../img/about_exquisite_left2.png';
import AboutExquisiteleft3 from '../img/about_exquisite_left3.png';
import FeatureImg1 from '../img/feature_icon1.png'; 
import FeatureImg2 from '../img/feature_icon2.png';
import FeatureImg3 from '../img/feature_icon3.png';
import MoveBusiness from '../elements/MoveBusiness';
import MoveBusinessImg from '../img/getstart.png';
import user from '../img/testimonial.png';
import HappyCustomers from '../elements/HappyCustomers';
import ContactSection from '../elements/ContactSection';
import OurStatatics from '../elements/OurStatatics.js';

export default function About() {

  const counter = [
    {
      countNum: '15+',
      lebal: 'Years in Business',
    },
    {
      countNum: '10m+',
      lebal: 'Happy Clients Served',
    },
    {
      countNum: '2m+',
      lebal: 'Trucks Deliverd till now',
    },
    {
      countNum: '1m+',
      lebal: 'Five Star Rating',
    }
  ]

  const features = [
    {
      featureImg: FeatureImg1,
      featureTitle: 'monitor Moving & Packing transactions easily',
      featureDes: 'You can monitor your Moving & Packing money transactions either into the bank or out of the bank.'
    },
    {
      featureImg: FeatureImg2,
      featureTitle: 'You can Track your Moving & Order analysis',
      featureDes: 'Analyze finances whether it is wasteful or not with the contest analysis feature.'
    },
    {
      featureImg: FeatureImg3,
      featureTitle: ' various payment options available',
      featureDes: 'Various Payment Options & Support over 10+ barriers, You do not have to worry about Payments. ​​'
    }
  ]

  const customers = [
    {
      title: "Excellent service, on time. Careful, courteous!",
      description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
      user: "Dianne Russell",
      userPost: "Exquisitemoves Director",
      useravatar: user,
      rating: "4.9"
    },
    {
      title: "Excellent service, on time. Careful, courteous!",
      description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
      user: "Dianne Russell",
      userPost: "Exquisitemoves Director",
      useravatar: user,
      rating: "4.9"
    },
    {
      title: "Excellent service, on time. Careful, courteous!",
      description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
      user: "Dianne Russell",
      userPost: "Exquisitemoves Director",
      useravatar: user,
      rating: "4.9"
    },
    {
      title: "Excellent service, on time. Careful, courteous!",
      description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
      user: "Dianne Russell",
      userPost: "Exquisitemoves Director",
      useravatar: user,
      rating: "4.9"
    },
    {
      title: "Excellent service, on time. Careful, courteous!",
      description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
      user: "Dianne Russell",
      userPost: "Exquisitemoves Director",
      useravatar: user,
      rating: "4.9"
    }, 

  ]

  return <>
    <Hero bg={AboutBanner} clsName="aboutbanner_sec" >
            <div className='pt-3 pt-sm-4 pt-lg-5 bannerTri' >
                <div className='row align-items-end' >
                    <div className='col-lg-12 pb-3 pb-lg-5 mt-3' >
                        <div className='banner_content py-0 pt-5' >
                            <Title mainClass="text-start"
                                titleclass="lg text-white mb-2 text-center"
                                desclass=" text-center mt-3 mb-2"
                                title={<>Test Stress-Free Moving & <br/> Junk Removal, We Move People Forward! </>}
                                des="ExquisiteMoves is the nation’s leading full-service moving company, offering customers comprehensive home and business relocation, packing and unpacking, and junk removal services."
                            />

                        </div>
                    </div>
                </div>
            </div>
        </Hero>
      
      <div className='video_sec'>
        <div className='container'>
          <div className='pcVid'>
            <video poster={packvideo} controls >
              <source src={movie} type="video/mp4" />
              <source src={movie} type="video/ogg" />
            </video>
          </div>
        </div>
      </div>

      <div className='pt-5 pb-0 pb-lg-5'>
        <div className='container'>
          <div className="serviceSec pt-0 pt-lg-5" >
                    <div className="row align-items-center flex-lg-row-reverse" >
                        <div className="col-lg-6" >
                            <Title mainClass="mb-3"
                                subheading="why Exquisite Moves ?"
                                subclass="mb-2 border-none text-start text-uppercase"
                                titleclass="lg heading text-dark text-start mb-3 mt-0 mt-lg-3"
                                desclass="my-3"
                                title={<>Internationally with more than 350 locations worldwide.</>}
                                des="It all started as an after-school business for two high school boys. The endeavor was never expected to be more than a local moving company."
                            /> 

                            <Checklist
                                list={["Nationwide Locations", "Book Online", "Upfront Pricing", "Office & Business Moving"]}
                                class="mt-0 mt-lg-4 mb-0 mb-lg-4  text-dark"
                                col="col-sm-6"
                                liststyle="normal" />


                            <div className='button_wrap d-flex align-items-center'>
                              <Btn class="mt-2"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                              >Book now</Btn>
                              <div className='price_div'>
                                <p>Service Starting from</p>
                                <div className='amount_text'>$199 <span className='del_text'><del>$299</del></span></div>
                              </div>
                            </div>
                        </div>
                        <div className="col-lg-6 pt-3 pt-lg-0 pe-xl-5" >
                            <img src={s4} className="img-fluid" alt="services" />
                        </div>
                    </div>
                </div>
        </div>
      </div>

      <OurStatatics />

      <div className='equisite_values pb-0 pt-5 pb-md-5 mb-0 mb-lg-3 mt-3'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <Title mainClass="mb-3"
                titleclass="lg heading text-center mb-3 mt-0 mt-lg-3"
                title={<>Exquisite Moves Core Values!</>}
              /> 
            </div>
            <div className='col-lg-6 mb-4 mb-lg-0'>
              <div className='values_box'>
                <h3>Integrity & Give back to the community!</h3>
                <p>To always conduct oneself with honesty and fairness. To treat everyone the way you would want your Grandma to be treated.</p>
                <TriImage mainclass="mt-3" 
                  img1={BookingImage1}
                  img2={BookingImage}
                  img3={BookingImage3} 
                />
              </div>
            </div>
            <div className='col-lg-6 mb-4 mb-lg-0'>
              <div className='values_box'>
                <h3>Be your best & have fun, Customer Care!</h3>
                <p>To be the best professionally and personally while enjoying life and having fun. To welcome people from all backgrounds in the workplace and the community.</p>
                <TriImage mainclass="mt-3" 
                  img1={CustomerCare1}
                  img2={CustomerCare2}
                  img3={BookingImage3} 
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='about_exquisite pt-0 pt-lg-5 pb-5'>
        <div className='container'>
          <div className='row flex-lg-row-reverse'>
            <div className='col-lg-6 ps-lg-4 '>
              <div className='about_exquisite_cnt'>
                <Title mainClass=""
                subheading="about Exquisite Moves"
                subclass="mb-2 border-none text-start text-uppercase"
                titleclass="lg heading text-dark text-start mb-0 mb-lg-3 mt-0 mt-lg-3"
                desclass="my-3"
                title={<>A Moving Company on a Mission to Exceed Expectations!</>}
                des="It all started as an after-school business for two high school boys. With a hand-drawn logo, advertisement in a local paper, and advertising fund stashed in a ceramic dish, the endeavor was never expected to be more than a local moving company."
              /> 
              </div>
            </div>
            <div className='col-lg-6 pe-lg-4 mt-3 mt-sm-4 mt-lg-0'>
              <div className='row flex-lg-row-reverse col-1-images align-items-end '>
                <div className='col-6' ><img src={AboutExquisiteleft2} alt="img" /></div>
                <div className='col-6' ><img src={AboutExquisiteleft1} alt="img" /></div>
              </div>
            </div>
          </div>
          <div className='row col-2-images mt-4 mt-lg-3'>
          <div className='col-6 pe-lg-3'>
                <img src={AboutExquisiteleft3} alt="img" />
            </div>
            <div className='col-6 ps-lg-3'>
                <img src={AboutExquisiteRight} alt="img"  />
            </div>
            </div>
        </div>
      </div>

      <div className='features_sec pt-3 pt-lg-5 mt-3 pb-0 mb-0 pb-xl-5 mb-xl-3'>
        <div className='container'>
          <Title mainClass="mb-4 mb-lg-5"
                titleclass="lg heading text-dark text-center mb-3 mt-0 mt-lg-3"
                desclass="my-3 text-center"
                title={<>Features that you can get <br /> in ExquisiteMoves!</>}
                des="Our goal is to tailor each experience to specifically fit all moving needs."
              /> 
          <div className='feature_list'>
            <div className='row' >
              {features.map((data, i) => {
                return<>
                  <div className='col-lg-4 mb-5 mt-lg-0' >
                    <div className='feature_box'>
                      <img src={data.featureImg} alt='icon' />
                      <h3>{data.featureTitle}</h3>
                      <p>{data.featureTitle}</p>
                    </div>
                  </div>
                </>
              })}
            </div>
          </div>
        </div>
      </div>

      <MoveBusiness moveImg={MoveBusinessImg} />
      <HappyCustomers customers={customers} /> 
      <ContactSection />
      <Newsletter />
      <Footer />
  </>
}
